import type { ComponentProps, MouseEvent } from 'react';

// eslint-disable-next-line no-restricted-imports
import { Link } from '@remarkable/ark-web';

import { LinkClicked } from 'src/ampli';
import { tracker } from 'src/analytics/tracker';
import type { SUPPORT_URL } from 'src/utils/urls/supportUrls';
import type { DEV_URLS, RM_COM_URLS } from 'src/utils/urls/urls';

type SupportArticles = (typeof SUPPORT_URL)['ARTICLES'];
type OtherSupportUrls = Omit<typeof SUPPORT_URL, 'ARTICLES'>;

export type ExternalURL =
  | SupportArticles[keyof SupportArticles]
  | OtherSupportUrls[keyof OtherSupportUrls]
  | (typeof RM_COM_URLS)[keyof typeof RM_COM_URLS]
  | (typeof DEV_URLS)[keyof typeof DEV_URLS];

type LinkExternalProps = Partial<ComponentProps<typeof Link>> & {
  /** Enables LinkClicked tracking events when set */
  componentLocation: string | undefined;
  to: ExternalURL | (string & NonNullable<unknown>);
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

export function LinkExternal({
  componentLocation: trackingLocation,
  onClick,
  to,
  ...props
}: LinkExternalProps) {
  const isRemarkableDomain = to.includes('remarkable.com');

  return (
    <Link
      target="_blank"
      rel={isRemarkableDomain ? 'noopener' : 'noopener noreferrer'}
      href={to}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        if (trackingLocation) {
          tracker.trackEvent(
            new LinkClicked({
              component_location: trackingLocation,
              text: event.currentTarget.innerText,
              link_source: to ?? '',
            })
          );
        }
        onClick?.(event);
      }}
      {...props}
    />
  );
}
